import { createSelector } from 'reselect'
import { selectSignalR } from '../store'

if (selectSignalR === undefined) throw new Error('selectSignalR is undefined')

export const selectSignalRIsConnected = createSelector(
    [selectSignalR],
    (signalR) => signalR.status === 'Connected'
)
